export enum EnumTipoNumeracao
{
    Global = 1,
    PorEmpresa
}

export const ListaTipoNumeracao = [
    { descricao: "Global", valor: EnumTipoNumeracao.Global },
    { descricao: "Por Empresa", valor: EnumTipoNumeracao.PorEmpresa }
];